// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetHash} from '../asset-hash.js'
import {PDFPageMapping} from '../search-index/pdfpage-mapping.js'
import {PDFPageRecognizedText} from '../search-index/pdfpage-recognized-text.js'
import {PDFPageTextLayout} from '../search-index/pdfpage-text-layout.js'

export class PDFFileIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFFileIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFFileIndex(bb: flatbuffers.ByteBuffer, obj?: PDFFileIndex): PDFFileIndex {
    return (obj || new PDFFileIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFFileIndex(bb: flatbuffers.ByteBuffer, obj?: PDFFileIndex): PDFFileIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFFileIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  assetHash(obj?: AssetHash): AssetHash | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetHash()).__init(this.bb_pos + offset, this.bb!) : null
  }

  pdfName(): string | null
  pdfName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  pdfName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  pageMappings(index: number, obj?: PDFPageMapping): PDFPageMapping | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? (obj || new PDFPageMapping()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  pageMappingsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  pageRecognizedText(index: number, obj?: PDFPageRecognizedText): PDFPageRecognizedText | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset
      ? (obj || new PDFPageRecognizedText()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  pageRecognizedTextLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  pageTextLayouts(index: number, obj?: PDFPageTextLayout): PDFPageTextLayout | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset
      ? (obj || new PDFPageTextLayout()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  pageTextLayoutsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startPDFFileIndex(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addAssetHash(builder: flatbuffers.Builder, assetHashOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, assetHashOffset, 0)
  }

  static addPdfName(builder: flatbuffers.Builder, pdfNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, pdfNameOffset, 0)
  }

  static addPageMappings(builder: flatbuffers.Builder, pageMappingsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, pageMappingsOffset, 0)
  }

  static createPageMappingsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startPageMappingsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addPageRecognizedText(builder: flatbuffers.Builder, pageRecognizedTextOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, pageRecognizedTextOffset, 0)
  }

  static createPageRecognizedTextVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startPageRecognizedTextVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addPageTextLayouts(builder: flatbuffers.Builder, pageTextLayoutsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, pageTextLayoutsOffset, 0)
  }

  static createPageTextLayoutsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startPageTextLayoutsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endPDFFileIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // asset_hash
    builder.requiredField(offset, 6) // pdf_name
    builder.requiredField(offset, 8) // page_mappings
    return offset
  }

  static createPDFFileIndex(
    builder: flatbuffers.Builder,
    assetHashOffset: flatbuffers.Offset,
    pdfNameOffset: flatbuffers.Offset,
    pageMappingsOffset: flatbuffers.Offset,
    pageRecognizedTextOffset: flatbuffers.Offset,
    pageTextLayoutsOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    PDFFileIndex.startPDFFileIndex(builder)
    PDFFileIndex.addAssetHash(builder, assetHashOffset)
    PDFFileIndex.addPdfName(builder, pdfNameOffset)
    PDFFileIndex.addPageMappings(builder, pageMappingsOffset)
    PDFFileIndex.addPageRecognizedText(builder, pageRecognizedTextOffset)
    PDFFileIndex.addPageTextLayouts(builder, pageTextLayoutsOffset)
    return PDFFileIndex.endPDFFileIndex(builder)
  }
}
